import React, { Component } from 'react';
import ReactCrop from 'react-image-crop';

const crop = {
  width: 100,
  height: 62,
};

class Box extends Component {
  renderLinkItem(linkItem, index) {
    const hasImage = linkItem && linkItem.image && linkItem.image.url;
    const key = linkItem && linkItem.id ? linkItem.id : `box-link-${index}`;

    return (
      <li key={key}>
        <a className="btn btn-primary" href={linkItem.route}>
          <span>
            {hasImage ? (
              <ReactCrop
                disabled={true}
                src={linkItem.image.url}
                crop={crop}
                className="top"
                onChange={() => {}}
              />
            ) : (
              <ReactCrop disabled={true} crop={crop} className="top" onChange={() => {}} />
            )}
            <figcaption className="center-text top2">{linkItem.text}</figcaption>
          </span>
        </a>
      </li>
    );
  }

  render() {
    const box = this.props.box || {};

    // Match the pattern you’re using elsewhere:
    // default to "internal", render seasonal links only when experience === "seasonal"
    const experience = window.localStorage.getItem('experience') || 'internal';
    console.log('[steve new value]:' + experience);
    console.log(box);
    const linksToRender =
      experience === 'seasonal' && Array.isArray(box.seasonalLink) && box.seasonalLink.length > 0
        ? box.seasonalLink
        : Array.isArray(box.link)
        ? box.link
        : [];

    return (
      <section className="section main-departments">
        <div className="section-content row department-items">
          <div className="col sm-12">
            <ul className="flex-container department-list">
              {linksToRender.map((lnk, idx) => this.renderLinkItem(lnk, idx))}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default Box;
